import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        trainingCompany: '=',
        uibModalInstance: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2 ng-if="!vm.trainingCompany.id">{{ 'general.Add' | translate }}</h2>
            <h2 ng-if="vm.trainingCompany.id">{{ 'general.Edit' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form-wrapper form="vm.form">
                <div class="form">
                    <form-row error="vm.form.errors.name">
                        <label class="label">{{ 'trainingCompany.Name' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <input ng-model="vm.form.model.name" type="text" class="form-control">
                        </div>
                    </form-row>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, toastr, FormFactory) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.toastr = toastr;
        this.FormFactory = FormFactory;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.trainingCompany);
    }

    save () {
        this.form.save().then(() => {
            this.toastr.success(this.$translate.instant('general.Changes saved'));
            this.uibModalInstance.close();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/trainingCompany/form/index.js